module.exports = __webpack_public_path__ + "img/第7章_2-2_「招財進寶」組合字.jpg";